<template>
  <FlexContainer class="listContainer" direction="row" :horizGap="1">
    <slot></slot>
  </FlexContainer>
</template>

<script>
import FlexContainer from "./FlexContainer.vue";

export default {
  components: {
    FlexContainer,
  },
};
</script>

<style scoped>
.listContainer {
  margin-top: 1rem;
}
</style>
